export default __webpack_public_path__ + "static/media/451.6cd95303.jpg";